import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2d6d79bd&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2d6d79bd&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_vue-template-compiler@2.7.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports